export const DataGynae = [
    {
        id:1,
        image:"/Images/Maternity/Gynaecology/General Gynaecology Sivaganga Sabari Hospital.webp",
        title:"General Gynaecology",
    },
    {
        id:3,
        image:"/Images/Maternity/Gynaecology/Well Women Clinic Sivaganga Sabari Hospital.webp",
        title:"Well Women Clinic",
    },
    {
        id: 5,
        image: "/Images/Maternity/Gynaecology/Family Planning  Sivaganga Sabari Hospital.webp",
        title: "Family Planning Clinic",
    },
    {
        id: 6,
        image: "/Images/Maternity/Gynaecology/Cancer Screening Sivaganga Sabari Hospital.webp",
        title: "Cancer Screening",
    },
    {
        id: 7,
        image: "/Images/Maternity/Gynaecology/Laproscopic Hysterectomy Sivaganga Sabari Hospital.webp",
        title: "Laproscopic Hysterectomy",
    },
    {
        id: 8,
        image: "/Images/Maternity/Gynaecology/Abdominal Hysterectomy Sivaganga Sabari Hospital.webp",
        title: "Abdominal Hysterectomy",
    },
    {
        id: 9,
        image: "/Images/Maternity/Gynaecology/Tubectomy Sivaganga Sabari Hospital.webp",
        title: "Tubectomy",
    },
    {
        id: 10,
        image: "/Images/Maternity/Gynaecology/Tubal Ligation Sivaganga Sabari Hospital.webp",
        title: "Tubal Ligation",
    },
    {
        id: 11,
        image: "/Images/Maternity/Gynaecology/Tubal Ligation Reversal Sivaganga Sabari Hospital.webp",
        title: "Tubal Ligation Reversal",
    },
    {
        id: 12,
        image: "/Images/Maternity/Gynaecology/Management of High-Risk Pregnancies Sivaganga Sabari Hospital.webp",
        title: "Management of High-Risk Pregnancies",
    },
    {
        id: 13,
        image: "/Images/Maternity/Gynaecology/Endometriosis Sivaganga Sabari Hospital.webp",
        title: "Endometriosis",
    },
];

